import NFSeService from "@/services/NFSeService";

export const nfse = {
  namespaced: true,
  state: {
    nfse: {},
  },
  actions: {
    getNFSe({ commit }, payload) {
      return NFSeService.GetNFSe(payload).then(
        (nfse) => Promise.resolve(nfse),
        (error) => Promise.reject(error.response.data)
      );
    },
    postNFSe({ commit }, payload) {
      return NFSeService.PostNFSe(payload).then(
        (nfse) => Promise.resolve(nfse),
        (error) => Promise.reject(error.response.data)
      );
    },
    putNFSe({ commit }, payload) {
      return NFSeService.PutNFSe(payload).then(
        (nfse) => Promise.resolve(nfse),
        (error) => Promise.reject(error.response.data)
      );
    },
    deleteNFSe({ commit }, payload) {
      return NFSeService.DeleteNFSe(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    getNFSeOData({ commit }, payload) {
      return NFSeService.GetNFSeOData(payload).then(
        (nfse) => Promise.resolve(nfse),
        (error) => Promise.reject(error)
      );
    },
  },
  mutations: {},
};

export default nfse;
